import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { InformationSideBarComponent } from './information-side-bar.component';
import { TranslatePipeModule} from '../translate/translate.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    NgxSelectModule,
    TranslatePipeModule
  ],
  declarations: [InformationSideBarComponent],
  providers: [],
  exports: [InformationSideBarComponent]
})

export class InformationSideBarModule {

}
